import { CartAddEvent } from '@theme/events';

const PRODUCT_A_ID = 9034810556642;

// What was already in the cart when the page loaded
let initialHasProductA = false;
let initialHasOtherProducts = false;

async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function removeLineItems(itemsToRemove) {
  for (const item of itemsToRemove) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 }),
    });
  }
}

// Run after an add-to-cart happens
async function enforceRestrictions() {
  const cart = await getCart();

  const hasProductA = cart.items.some((item) => item.product_id === PRODUCT_A_ID);
  const hasOtherProducts = cart.items.some((item) => item.product_id !== PRODUCT_A_ID);

  // Cart is valid if it only has Product A, only others, or is empty
  if (!hasProductA || !hasOtherProducts) {
    return;
  }

  let itemsToRemove = [];
  let message = '';

  // Case 2: Other products were already in cart, and Product A was just added
  if (initialHasOtherProducts && !initialHasProductA) {
    itemsToRemove = cart.items.filter((item) => item.product_id === PRODUCT_A_ID);
    message =
      'Pre-order items cannot be purchased with other products in the same cart. Please check out separately.';
  } else {
    // Case 1 (default): Product A was already in cart, and a new product was added
    itemsToRemove = cart.items.filter((item) => item.product_id !== PRODUCT_A_ID);
    message =
      'Pre-order items cannot be purchased with other products in the same cart. Please check out separately.';
  }

  if (itemsToRemove.length > 0) {
    await removeLineItems(itemsToRemove);
    alert(message);
    // Reload to show updated cart state everywhere (drawer, cart page, etc.)
    location.reload();
  }
}

// Get the starting cart state once when the page loads
document.addEventListener('DOMContentLoaded', async () => {
  try {
    const cart = await getCart();
    initialHasProductA = cart.items.some((item) => item.product_id === PRODUCT_A_ID);
    initialHasOtherProducts = cart.items.some((item) => item.product_id !== PRODUCT_A_ID);
  } catch (e) {
    console.error('Failed to load cart:', e);
  }
});

// Listen to the same event Horizon uses when something is added to the cart
document.addEventListener(CartAddEvent.eventName, () => {
  enforceRestrictions().catch((e) => console.error('Restriction error:', e));
});
